import React from "react";
import { TextField, TextAreaField } from "../inputs";
import GenericFields from "./GenericFields";
import SignatureSection from "./SignatureSection";

export default function LeaveOfAbsence() {
  return (
    <form
      method="POST"
      action="/student-request/leave-of-absence"
      onSubmit={() => {
        setSubmitting(true);
      }}
    >
      <GenericFields />

      <p>
        To initiate the leave of absence process, please fill out the fields
        below. A representative from the academics department or the Office of
        the Registrar will reach out to you with further instructions.
      </p>

      <div className="form-row">
        <div className="form-item">
          <TextField
            type="date"
            label="Expected last date of attendance"
            name="data[last_attendance_date]"
            required
          />
        </div>

        <div className="form-item">
          <TextField
            type="date"
            label="Expected return date from leave of absence"
            name="data[return_date]"
            required
          />
        </div>
      </div>

      <TextAreaField
        label="Reason for leave of absence"
        name="data[leave_reason]"
        rows={5}
        required
      />

      <SignatureSection />
    </form>
  );
}
